"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicroPurityFilter = exports.State = exports.getScheduledReplaceInterval = exports.Market = void 0;
const effect_1 = require("effect");
const volume_1 = require("../../../../../unit/volume");
const _util_1 = require("./_util");
const Definition = __importStar(require("./common"));
const NAMESPACE = 'Culligan.Device.Capability.Consumable.Definition.MicroPurityFilter';
const TAG = 'MicroPurityFilter';
const LABEL = 'MicroPurity Filter';
exports.Market = effect_1.Schema.Literal('Commercial', 'Residential').annotations({
    identifier: `${NAMESPACE}.Market`,
    description: 'The market a specific catalogue item is intended for',
});
/**
 * {@link MicroPurityFilter}s should be replaced after being installed for a market-dependent interval
 */
exports.getScheduledReplaceInterval = effect_1.Match.type().pipe(effect_1.Match.withReturnType(), effect_1.Match.when('Commercial', () => ({ months: 6 })), effect_1.Match.when('Residential', () => ({ years: 1 })), effect_1.Match.exhaustive);
exports.State = Definition.BaseState.pipe(effect_1.Schema.extend(Definition.ExpendableState), effect_1.Schema.extend(Definition.ExpirableState)).annotations({
    identifier: `${NAMESPACE}.State`,
    title: `${LABEL} State`,
});
class MicroPurityFilter extends Definition.ExpendableInLiters.extend(`${NAMESPACE}.${TAG}`)({
    _tag: effect_1.Schema.tag(TAG),
    ...Definition.Fields,
    market: effect_1.Schema.optionalWith(exports.Market, { exact: true }),
}, {
    identifier: `${NAMESPACE}.${TAG}`,
    title: LABEL,
    description: '0.2 micron filter used within HydroTap devices',
}) {
    static id = 'micropurity_filter';
    static label = LABEL;
    static category = Definition.Category.Filter;
    static expirable = true;
    static hasBatch = false;
    static Market = exports.Market;
    static State = exports.State;
    static catalogue = {
        micropurity_residential: this.make({
            id: 'micropurity_residential',
            name: 'MicroPurity Filter (Residential)',
            market: 'Residential',
            rangeTrigger: volume_1.Liter.make({ amount: 3_750 }),
            rangeExhaust: volume_1.Liter.make({ amount: 4_000 }),
        }),
        micropurity_commercial: this.make({
            id: 'micropurity_commercial',
            name: 'MicroPurity Filter (Commercial)',
            market: 'Commercial',
            rangeTrigger: volume_1.Liter.make({ amount: 5_500 }),
            rangeExhaust: volume_1.Liter.make({ amount: 6_000 }),
        }),
    };
    static legacyCatalogueItemIdMap = {};
    static CatalogueItemFromId = (0, _util_1.makeCatalogueItemFromId)(this).annotations({
        identifier: `${NAMESPACE}.CatalogueItemFromId`,
    });
    /**
     * See {@link getScheduledReplaceInterval}
     */
    static getScheduledReplaceInterval = exports.getScheduledReplaceInterval;
}
exports.MicroPurityFilter = MicroPurityFilter;
Definition.satisfiesConstructor(MicroPurityFilter);
//# sourceMappingURL=micro-purity-filter.js.map